import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
  DialogContent,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";

import {
  getTrainings,
  getTraineeCategories,
  approveTraining,
  cancelTraining,
  getVenueTypes,
} from "../../../../store/cpd/actions";
import { getDistricts } from "../../../../store/posts/actions";
import { CSVLink } from "react-csv";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import ReactPaginate from "react-paginate";

import TrainingFormDialog from "../components/TrainingFormDialog";
import TrainingFormWizardDialog from "../components/TrainingFormWizardDialog";
import PreviewTrainingDialog from "../components/PreviewTrainingDialog";
import axios from "axios";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import TrainingTraineesDialog from "../components/TrainingTraineesDialog";
import { showError } from "../../../toastify";

const Trainings = (props) => {
  useEffect(() => {
    document.title = "TMIS | CPD - Trainings";
  }, []);

  const {
    user,
    loading,
    trainings,
    getTrainings,
    approveTraining,
    getDistricts,
    getTraineeCategories,
    cancelTraining,
    getVenueTypes,
  } = props;

  useEffect(() => {
    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
    };

    getTrainings(query, setTotalRecods, setLoader);

    getDistricts();
    getTraineeCategories();
    getVenueTypes();
  }, [user?.selectedEntity, user?.selectedAcademicYear]);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [loader, setLoader] = useState(false);

  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 10,
  );

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);

    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getTrainings(query, setTotalRecods, setLoader);
  };

  const { hasPermissions } = useRequiredAuth();

  const onSearch = (term) => {
    setSearchTerm(term);

    if (term === "") {
      const _currentPage = 1;
      setCurrentPage(_currentPage);

      const _searchTerm = "";
      setSearchTerm(_searchTerm);

      const query = {
        searchTerm: _searchTerm,
        page: _currentPage,
        size: itemPerPage,
      };
      getTrainings(query, setTotalRecods, setLoader);
    }
  };

  const [showTrainingFormDialog, setShowTrainingFormDialog] = useState(false);
  const [showTrainingFormWizardDialog, setShowTrainingFormWizardDialog] =
    useState(false);

  const [trainingDrafts, setTrainingDrafts] = useState([]);
  const [resumeDraftId, setResumeDraftId] = useState(null);
  const [resumeFormSnapshot, setResumeFormSnapshot] = useState(null);
  const [resumeNeedsAssessmentFilePath, setResumeNeedsAssessmentFilePath] =
    useState(null);

  const fetchTrainingDrafts = async () => {
    try {
      const { data } = await axios.get("/api/cpd/training-drafts");
      setTrainingDrafts(Array.isArray(data) ? data : []);
    } catch {
      setTrainingDrafts([]);
    }
  };

  useEffect(() => {
    fetchTrainingDrafts();
  }, [user?.selectedEntity, user?.selectedAcademicYear]);

  useEffect(() => {
    if (!showTrainingFormDialog && !showTrainingFormWizardDialog) {
      fetchTrainingDrafts();
    }
  }, [showTrainingFormDialog, showTrainingFormWizardDialog]);

  const clearResumeDraft = () => {
    setResumeDraftId(null);
    setResumeFormSnapshot(null);
    setResumeNeedsAssessmentFilePath(null);
  };

  const onContinueDraft = async (id) => {
    try {
      const { data } = await axios.get(`/api/cpd/training-drafts/${id}`);
      setResumeDraftId(data.id);
      setResumeFormSnapshot(data.formSnapshot);
      setResumeNeedsAssessmentFilePath(data.needsAssessmentFilePath || null);
      setShowTrainingFormWizardDialog(true);
    } catch (e) {
      showError(e);
    }
  };

  const onDiscardDraft = async (id) => {
    try {
      await axios.delete(`/api/cpd/training-drafts/${id}`);
      await fetchTrainingDrafts();
    } catch (e) {
      showError(e);
    }
  };

  return (
    <>
      <div className="px-4 pt-2">
        {hasPermissions(["CPD_TRAININGS_APPLY"]) &&
          trainingDrafts.length > 0 && (
            <div className="mb-3 border rounded bg-white p-3 shadow-sm">
              <Typography
                variant="subtitle2"
                className="text-primary mb-2 font-weight-bold"
              >
                Saved drafts
              </Typography>
              <div className="d-flex flex-column gap-2">
                {trainingDrafts.map((d) => (
                  <div
                    key={d.id}
                    className="d-flex flex-wrap align-items-center justify-content-between border rounded p-2 bg-light"
                  >
                    <div className="mr-2 mb-2 mb-md-0">
                      <strong>{d.title || "Untitled training"}</strong>
                      <div className="text-muted small">
                        Last updated {new Date(d.updatedOn).toLocaleString()}
                        {d.hasNeedsAssessmentFile
                          ? " · Needs assessment PDF saved"
                          : ""}
                      </div>
                    </div>
                    <div>
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        className="mr-1"
                        onClick={() => onContinueDraft(d.id)}
                      >
                        Continue
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={() => onDiscardDraft(d.id)}
                      >
                        Discard
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        <div className="border rounded">
          <AppBar position="static" elevation={0} className="app-bar w-100">
            <Toolbar
              style={{
                minHeight: "0px",
                borderBottom: "3px solid #e9ecef",
              }}
              className=" my-0 py-1 bg-light"
            >
              <Typography
                variant="p"
                noWrap
                component="div"
                className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
              >
                <span className="text-dark">({totalRecods}) Trainings</span>

                <CSVLink
                  data={trainings}
                  filename={`Training providers.csv`}
                  className="hidden"
                  id="downloadBTN"
                  target="_blank"
                />
                {hasPermissions(["CPD_TRAININGS_DOWNLOAD"]) && (
                  <Tooltip title="Download">
                    <span className="ml-2">
                      <IconButton
                        size="small"
                        disabled={loading || !trainings.length}
                        className=" mr-1"
                        color="primary"
                        onClick={() =>
                          document.getElementById("downloadBTN").click()
                        }
                      >
                        <span className="material-icons">file_download</span>
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Typography>

              <Box sx={{ flexGrow: 1 }} />
              {/* {hasPermissions(["CPD_TRAININGS_APPLY"]) && (
                <Button
                  className="mr-2"
                  onClick={() => {
                    clearResumeDraft();
                    setShowTrainingFormDialog(true);
                  }}
                  variant="contained"
                  size="small"
                  disableElevation
                  color="primary"
                >
                  <span className="material-icons">add</span>
                  New training
                </Button>
              )} */}
              {hasPermissions(["CPD_TRAININGS_APPLY"]) && (
                <Button
                  className="mr-2"
                  onClick={() => {
                    clearResumeDraft();
                    setShowTrainingFormWizardDialog(true);
                  }}
                  variant="outlined"
                  size="small"
                  disableElevation
                  color="primary"
                >
                  <span className="material-icons">add</span>
                  New training
                </Button>
              )}
              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                <SearchBox
                  onSearch={onSearch}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                      };

                      getTrainings(query, setTotalRecods, setLoader);
                    }
                  }}
                  placeholder="Search…"
                />
              </Box>
            </Toolbar>
          </AppBar>
          <div
            style={{
              backgroundColor: "#f3f4f6",
              borderRadius: "0.5rem",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
              height: "59vh",
              overflowY: "auto",
            }}
            className="px-3"
          >
            {!!trainings.length && (
              <table className="table table-striped table-hover   fixTableHead">
                <thead>
                  <tr style={{ backgroundColor: "#f0f2f5" }}>
                    <th scope="col">#</th>
                    <th scope="col">Training number</th>
                    <th scope="col">Title</th>
                    <th scope="col">Program</th>
                    <th scope="col">Provider</th>
                    {/* <th scope="col">Sub program</th> */}
                    <th scope="col">Topics</th>
                    {/* <th scope="col">Needs assessment</th> */}
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                  </tr>
                </thead>

                <tbody>
                  {trainings.map((item) => (
                    <ItemCard
                      key={item.id}
                      item={item}
                      user={user}
                      loading={loading}
                      // setShowFormDialog={setShowFormDialog}
                      // deleteScholarshipRequest={deleteScholarshipRequest}
                      approveTraining={approveTraining}
                      // env={env}
                      hasPermissions={hasPermissions}
                      cancelTraining={cancelTraining}
                    />
                  ))}
                </tbody>
              </table>
            )}

            {!trainings?.length && (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container py-5 ">
                  <p className="lead">
                    {loading ? "Fetching data..." : "No record found"}{" "}
                  </p>
                </div>
              </div>
            )}
          </div>
          {!!trainings.length && (
            <div
              className="d-flex justify-content-center  align-items-center"
              style={{ overflow: "hidden" }}
            >
              <>
                <div className="mt-3">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={Math.ceil(totalRecods / itemPerPage)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
                    activeLinkClassName="active"
                  />
                </div>

                <select
                  className="custom-select custom-select-sm mr-3 ml-2"
                  style={{ width: "100px" }}
                  value={itemPerPage}
                  onChange={(event) => {
                    const itemPerPage = +event.target.value;
                    window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                    setItemPerPage(itemPerPage);
                    const query = {
                      searchTerm: searchTerm,
                      page: currentPage,
                      size: itemPerPage,
                    };
                    getTrainings(query, setTotalRecods, setLoader);
                  }}
                >
                  {[10, 50, 100, 150].map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
              </>
            </div>
          )}
        </div>
      </div>

      {loader && (
        <CircularProgress
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "rgb(7, 142, 206)",
            position: "absolute",
            top: "42%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
          size={40}
          thickness={4}
        />
      )}

      {showTrainingFormDialog && (
        <TrainingFormDialog
          showTrainingFormDialog={showTrainingFormDialog}
          setShowTrainingFormDialog={setShowTrainingFormDialog}
          resumeDraftId={resumeDraftId}
          resumeFormSnapshot={resumeFormSnapshot}
          resumeNeedsAssessmentFilePath={resumeNeedsAssessmentFilePath}
          onClearResumeDraft={clearResumeDraft}
        />
      )}

      {showTrainingFormWizardDialog && (
        <TrainingFormWizardDialog
          showTrainingFormDialog={showTrainingFormWizardDialog}
          setShowTrainingFormDialog={setShowTrainingFormWizardDialog}
          resumeDraftId={resumeDraftId}
          resumeFormSnapshot={resumeFormSnapshot}
          resumeNeedsAssessmentFilePath={resumeNeedsAssessmentFilePath}
          onClearResumeDraft={clearResumeDraft}
        />
      )}
      {/* 
      {showScholarshipSummary && (
        <ScholarshipSummaryDialog
          showDialog={showScholarshipSummary}
          setShowDialog={setShowScholarshipSummary}
          executed={scholarshipRequests.find(
            ({ statusId }) => !![3, 5].includes(statusId)
          )}
        />
      )} */}

      {/* {confirmExecute && (
        <ConfirmationDialog
          confirmationDialog={confirmExecute}
          message="Are you sure you want to excute scholarship algorithm?"
          setConfirmationDialog={setConfirmExecute}
          onYes={() => {
            executeScholarshipAlgorithm(setConfirmExecute);
          }}
        />
      )} */}
    </>
  );
};

const mapStateToProps = ({ user, loading, trainings }) => {
  return { user, loading, trainings };
};
export default connect(mapStateToProps, {
  getTrainings,
  approveTraining,
  getDistricts,
  getTraineeCategories,
  cancelTraining,
  getVenueTypes,
})(Trainings);

const ItemCard = (props) => {
  const {
    loading,
    user,
    item,
    hasPermissions,
    approveTraining,
    cancelTraining,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const entityRole = user?.selectedEntity?.role;
  /** Trainers and head teachers must not open preview or delete/cancel from this menu. */
  const mayUseTrainingPreviewOrDelete =
    entityRole !== "CPD_TRAINER" && entityRole !== "HEAD_TEACHER";

  /** DDE should manage trainees locally but must not preview full training intake from this menu. */
  const mayShowTrainingPreview =
    mayUseTrainingPreviewOrDelete && entityRole !== "DDE";

  const [showAttachmentsDialog, setShowAttachmentsDialog] = useState(false);

  const [statusId, setStatusId] = useState(null);
  const [statusComment, setStatusComment] = useState("");

  const [showTrainingPreviewDialog, setShowTrainingPreviewDialog] =
    useState(false);

  const [showTrainingTopicsDialog, setShowTrainingTopicsDialog] =
    useState(false);

  const [showConfirmCancel, setShowConfirmCancel] = useState(false);

  const [showTraineesDialog, setShowTraineesDialog] = useState(false);

  return (
    <>
      <tr>
        <td className="text-left">{item.no}</td>
        <td className="text-left">
          <strong>{item.id}</strong>
        </td>
        <td className="text-left">{item.title}</td>
        <td className="text-left">
          {item.programName} / {item.subProgramName}
        </td>
        {/* <td className="text-left">{item.subProgramName}</td> */}
        <td className="text-left">{item.providerName}</td>
        <td className="text-left">
          <button
            onClick={() => setShowTrainingTopicsDialog(true)}
            className="btn btn-link btn-sm text-truncate"
          >
            ({item.topics}) Topics
          </button>
        </td>

        <td className={`text-left`}>
          <span
            className={`badge badge-${item.statusId == 1
              ? "secondary"
              : [3, 4].includes(item.statusId)
                ? "danger"
                : "success"
              }`}
          >
            {item.statusName}
          </span>
        </td>

        <td className="text-right">
          <IconButton
            size="small"
            onClick={handleOpenMenu}
            aria-label="settings"
          >
            <Badge color="info">
              <span className="material-icons">more_horiz</span>
            </Badge>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 2,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 15,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {mayShowTrainingPreview && (
              <span>
                <MenuItem
                  onClick={(e) => {
                    handleCloseMenu();
                    setShowTrainingPreviewDialog(true);
                  }}
                  className={`text-dark font-weight-bolder`}
                >
                  <span className="material-icons  mr-1">open_in_new</span>
                  Preview
                </MenuItem>
                <Divider className="my-1" />
              </span>
            )}

            {![1, 3].includes(item.statusId) &&
              (hasPermissions(["CPD_TRAININGS_VIEW_TRAINEES"])) && (
                <span>
                  <MenuItem
                    onClick={(e) => {
                      handleCloseMenu();
                      setShowTraineesDialog(true);
                    }}
                    className="text-dark font-weight-bolder"
                  >
                    <span className="material-icons  mr-1">groups</span>
                    Trainees
                  </MenuItem>
                  <Divider className="my-1" />
                </span>
              )}

            {mayUseTrainingPreviewOrDelete &&
              ((item.statusId === 1 &&
                hasPermissions(["CPD_TRAININGS_APPLY"])) ||
                hasPermissions(["CPD_TRAININGS_APPROVE"])) && (
                <span>
                  <MenuItem
                    disabled={item.statusId === 4}
                    onClick={(e) => {
                      handleCloseMenu();
                      setShowConfirmCancel(true);
                    }}
                    className="text-danger"
                  >
                    <span className="material-icons mr-1">
                      remove_circle_outline
                    </span>
                    {item.statusId === 1 ? "Delete" : "Cancel"}
                  </MenuItem>
                </span>
              )}
          </Menu>
        </td>
      </tr>

      {showTrainingPreviewDialog && (
        <PreviewTrainingDialog
          showDialog={showTrainingPreviewDialog}
          setShowDialog={setShowTrainingPreviewDialog}
          training={item}
        />
      )}

      {showTrainingTopicsDialog && (
        <TrainingTopicsDialog
          showDialog={showTrainingTopicsDialog}
          setShowDialog={setShowTrainingTopicsDialog}
          training={item}
        />
      )}

      {showTraineesDialog && (
        <TrainingTraineesDialog
          showDialog={showTraineesDialog}
          setShowDialog={setShowTraineesDialog}
          training={item}
        />
      )}

      {!!showConfirmCancel && (
        <ConfirmationDialog
          disabled={!statusComment && item.statusId !== 1}
          confirmationDialog={showConfirmCancel}
          message={
            <>
              <p className="mt-2">
                Are you sure you want to{" "}
                <strong className={`text-danger`}>
                  {item.statusId === 1 ? "delete" : "cancel"}
                </strong>{" "}
                this training?
              </p>

              {item.statusId !== 1 && (
                <TextField
                  multiline
                  rows={3}
                  autoFocus
                  fullWidth
                  type="text"
                  size="small"
                  name="reason"
                  label="Reason for cancelation"
                  variant="outlined"
                  placeholder="Reason for cancelation"
                  value={statusComment}
                  onChange={(e) => {
                    setStatusComment(e.target.value || "");
                  }}
                />
              )}
            </>
          }
          setConfirmationDialog={setShowConfirmCancel}
          onYes={() => {
            cancelTraining({ id: item.id, comment: statusComment }, () =>
              setShowConfirmCancel(false),
            );
          }}
        />
      )}
    </>
  );
};

const TrainingTopicsDialog = (props) => {
  const { user, loading, onWait, showDialog, setShowDialog, training } = props;

  const onClose = () => {
    setShowDialog(false);
  };

  const [trainingTopics, setTrainingTopics] = useState([]);

  const getTrainingTopics = async () => {
    try {
      const { data } = await axios.get(
        `/api/cpd/training-topics/${training.id}`,
      );

      setTrainingTopics(data);
    } catch (error) { }
  };

  useEffect(() => {
    getTrainingTopics();
  }, [training]);

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className="text-primary pb-0 mb-0 text-uppercase border">
          <span className="d-flex align-items-center mb-2">
            <Typography className="d-flex align-items-center text-primary">
              <span className="text-dark mr-1">
                [{trainingTopics.length}] Training Topics
              </span>
            </Typography>
          </span>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div className="mt-3">
            {!!trainingTopics.length ? (
              <table className="table table-striped">
                <thead>
                  <tr style={{ backgroundColor: "#f0f2f5" }}>
                    <th scope="col" style={{ width: "32px" }}>
                      #
                    </th>
                    <th scope="col">Topic name</th>
                  </tr>
                </thead>

                <tbody>
                  {trainingTopics.map((topic, index) => (
                    <tr>
                      <td className="text-left">{index + 1}</td>
                      <td className="text-left">{topic.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container">
                  <p className="lead">
                    {loading ? "Fetching data..." : "No record found"}{" "}
                  </p>
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
